import React, { useState, useEffect } from 'react';
import api from '../../lib/api';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Bell, CheckCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function Notifications() {
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const [loading, setLoading] = useState(true);

  const fetch = () => {
    api.get('/notifications').then(r => { setData(r.data); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(() => { fetch(); }, []);

  const markAllRead = async () => {
    try {
      await api.patch('/notifications/read-all');
      toast.success('All marked as read');
      fetch();
    } catch {}
  };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-6 h-6 border-2 border-emerald-700 border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900 tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>Notifications</h1>
          <p className="text-slate-500 text-sm mt-0.5">{data.unread} unread</p>
        </div>
        {data.unread > 0 && (
          <Button variant="outline" size="sm" onClick={markAllRead} data-testid="mark-all-read-btn">
            <CheckCheck size={14} className="mr-1" /> Mark All Read
          </Button>
        )}
      </div>

      {data.notifications.length === 0 ? (
        <Card className="bg-white border border-slate-200 shadow-sm rounded-2xl">
          <CardContent className="py-12 text-center">
            <Bell size={40} className="mx-auto text-slate-300 mb-3" />
            <p className="text-slate-500">No notifications</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-2">
          {data.notifications.map((n, i) => (
            <Card key={i} className={`bg-white border shadow-sm rounded-xl ${!n.read ? 'border-emerald-200 bg-emerald-50/30' : 'border-slate-200'}`} data-testid={`notification-${i}`}>
              <CardContent className="p-4">
                <div className="flex items-start gap-3">
                  <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${!n.read ? 'bg-emerald-500' : 'bg-slate-300'}`} />
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-slate-900">{n.title}</p>
                    <p className="text-sm text-slate-500 mt-0.5">{n.message}</p>
                    <p className="text-xs text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
